//Constants
const EMPTY_STRING = "";
const UNDEFINED = "undefined";
const SEPARATOR = ".";
const OBJECT = "object";
const NULL = "null";

/**
 * Returns the show more label
 */
const showMoreLabel = () => {
    return $(".label-show-more").text();
};

/**
 * Return the show less label
 */
const showLessLabel = () => {
    return $(".label-show-less").text();
};

/**
 * Returns the root category object
 * @return {Object}- returns the root category object
 */
const getRootCategoryObject = () => {
 
    var rootCategory = window.rootCategoryObj || {};
    var categoryObjectL4 = getForthLevelCLPCategoryObject();



    if (categoryObjectL4) {
        rootCategory = unifyObjectProperties(rootCategory, categoryObjectL4);
    }
    
    return rootCategory;
};

/**
 * Returns the category tree object
 * @return {Object} - the category tree object
 */
const getCategoryTree = () => {
    var catTreeObjectL4 = getForthLevelCLPCategoryTree();
    var categoryTree = window.categoryTree || {};



    if (catTreeObjectL4) {
        categoryTree = unifyObjectPropertiesByKey(categoryTree, catTreeObjectL4);
    }

    return categoryTree;
};

/**
 * Get the category refinement information for CLP - L4
 */
const getCategoryForthLevelConfig = () => {
    const $elem = $(".js-forth-level-categories");
    let config = null;

    if ($elem.length > 0) {
        config = $elem.data("categoryObject");
    }

    return config && config.data ? config.data : null;
};

/**
 * Get the category config for the forth level of category refinements
 */
const getForthLevelCLPCategoryObject = () => {
    const configObj = getCategoryForthLevelConfig();
    return configObj && configObj.categoryObject ? configObj.categoryObject : null;
};

/**
 * Get the category config for the forth level of category refinements
 */
const getForthLevelCLPCategoryTree = () => {
    const configObj = getCategoryForthLevelConfig();
    return configObj && configObj.categoryTreeObject ? configObj.categoryTreeObject : null;
};

/**
 * Unifies the properties between 2 objects resulting in a new object iterating over subcategories until the matching object is found
 * @param {Object} categoryA 
 * @param {Object} categoryB 
 * @return {Object} - the category object with the unified properties
 */
const unifyObjectProperties = (categoryA, categoryB) => {
    if (categoryA.subCategories) {
        for (var i = 0; i < categoryA.subCategories.length; i++) {
            if (categoryA.subCategories[i].id == categoryB.id) {
                categoryA.subCategories[i] = categoryB;
                break;
            } else {
                unifyObjectProperties(categoryA.subCategories[i], categoryB);
            }
        }
    } else if (categoryA.id == categoryB.id) {
        categoryA = categoryB;
    }

    return categoryA;
};

/**
 * Unifies the properties between 2 objects resulting in a new object iterating over categories 
 * @param {Object} categoryA 
 * @param {Object} categoryB 
 * @return {Object} - the category object with the unified properties
 */
const unifyObjectPropertiesByKey = (categoryA, categoryB) => {
    var keysA = Object.keys(categoryA);
    var keyB = Object.keys(categoryB)[0];
    
    for (var i = 0; i < keysA.length; i++) {
        if (keysA[i] == keyB) {
            categoryA[keyB] = categoryB[keyB];
        } else {
            if (typeof categoryA[keysA[i]] == "object" && categoryA[keysA[i]] != "") {
                unifyObjectPropertiesByKey(categoryA[keysA[i]], categoryB);
            }
        }
    }

    return categoryA;
};

/**
 * Returns the path for a key inside an object provided as parameters
 * @param {Object} pathTree - the object to be covered
 * @param {String} key - the key attribute to be found
 * @param {String} currentPath - the path that is built for the key
 * @param {String} path - the path that is returned at the end
 */
const getObjectKeyPath = (pathTree, key, currentPath, path) => {
    currentPath = currentPath || EMPTY_STRING;
    path = path || EMPTY_STRING;
    var keys = Object.keys(pathTree);

    for (var i = 0; i < keys.length; i++) {
        if (keys[i] == key) {
            path = currentPath != EMPTY_STRING ? currentPath + SEPARATOR + key : key;
        } else if (typeof pathTree[keys[i]] == OBJECT) {
            var tempPath = currentPath != EMPTY_STRING ? currentPath + SEPARATOR + keys[i] : keys[i];
            path = getObjectKeyPath(pathTree[keys[i]], key, tempPath, path);
        }
    }

    return path;
};

/**
 * Builds the url with the query string for category refinements
 * @param {String} categoryID - the category ID used to build the query string
 */
const buildCategoryRefinementURL = categoryID => {
    var refineURL = $(".js-category-refinements-data-url").attr("data-category-refinement-url");
    var homepageURL =  $(".js-homepage-data-url").attr("data-homepage-url");

    if (![EMPTY_STRING, NULL, UNDEFINED].includes(categoryID)) {
        return [refineURL, "cgid=" + categoryID].join("?");
    }

    return homepageURL;
};

/**
 * Updates the structure for categories objects. Based on the list parameter it updates categories objects.
 * 
 * @param {Array} list
 * @param {Array} categories
 * @param {Boolean} keepSubCategories
 * @param {String} prevCategory
 * @return {Array} - returns the categories collection updated
 */
const updateFilterCategoryStructure = (list, categories, keepSubCategories) => {
    var category = list.length ? list[0] : null;
    keepSubCategories = typeof keepSubCategories != UNDEFINED ? keepSubCategories : false;

    if (category) {
        //removes the current category
        list.shift();
        var categoryObject = null;
    
        for (let i = 0; i < categories.length; i++) {
            if (categories[i].id != category) {
                categories[i].selected = false;
                delete categories[i].subCategories;
            } else {
                categoryObject = categories[i];
            }
        }

        if (categoryObject) {
            let subCategories = categoryObject.subCategories;
            categoryObject.selected = categoryObject.id == category && list.length == 0;
            let isSelectedCategoryReached = categoryObject.selected;

            if (isSelectedCategoryReached && subCategories != undefined) {
                for (let j = 0; j < subCategories.length; j++) {
                    if (subCategories[j].subCategories) {
                        delete subCategories[j].subCategories;
                    }
                }
            }

            if (!isSelectedCategoryReached && list.length && subCategories && subCategories.length) {
                categoryObject.subCategories = updateFilterCategoryStructure(list, subCategories, keepSubCategories);
            }
        }
    }

    return categories;
};

/**
 * Filter the refinements for the top level category selected
 * @param {Object} rootCategory 
 */
const filterRefinementsForTopCategory = (rootCategory) => {
    var subCategories = [];
    
    if (rootCategory) {
        subCategories = rootCategory.subCategories;

        for (let i = 0; i < subCategories.length; i++) {
            subCategories[i].selected = false;
            delete subCategories[i].subCategories;
        }
    }

    return subCategories;
};

/**
 * Filter through the categories object saved in session privacy and returns the list of categories to be displayed in the refinements
 * The filtering is done based on the position of the category selected.
 * @param {String} categoryID 
 * @param {Boolean} keepSubCategories 
 * @return {Object} returns the categories filtered
 */
const filterRefinementCategories = (categoryID, keepSubCategories) => {
    //Used this approach to determine to create a new object reference so that the original object is not affected
    var rootCategory = getRootCategoryObject();
    var categoryTree = getCategoryTree();
    var subCategories = rootCategory.subCategories;
    var newCategories = [];
    var isTopLevelCLPPage = false;

    if (typeof subCategories == UNDEFINED || subCategories == EMPTY_STRING || categoryID == EMPTY_STRING) {
        return EMPTY_STRING;
    }

    if (rootCategory.id == categoryID) {
        return {
            categories: filterRefinementsForTopCategory(rootCategory),
            isTopLevelCLPPage: true
        };
    }

    var categoryPath = getObjectKeyPath(categoryTree, categoryID);
    var list = categoryPath.split(SEPARATOR);

    var firstLevelCategory = "";

    if (list && list.length > 1) {
        firstLevelCategory = list[1];
    }
    
    //Removes top category from list
    list.shift();
    var categoryPathFull = "";
    if (list.length > 0) {
        categoryPathFull = list.join("/");
    }
    newCategories = updateFilterCategoryStructure(list, subCategories, keepSubCategories);

    return {
        categories: newCategories,
        isTopLevelCLPPage: isTopLevelCLPPage,
        firstLevelCategory: firstLevelCategory, 
        categoryPathFull: categoryPathFull
    };
};

export {
    getRootCategoryObject, 
    getCategoryTree, 
    getCategoryForthLevelConfig, 
    getForthLevelCLPCategoryObject, 
    getForthLevelCLPCategoryTree, 
    unifyObjectProperties, 
    unifyObjectPropertiesByKey, 
    getObjectKeyPath, 
    buildCategoryRefinementURL, 
    updateFilterCategoryStructure, 
    filterRefinementsForTopCategory, 
    filterRefinementCategories,
    showMoreLabel,
    showLessLabel
};
